// import jQuery from 'CommonScripts/jquery-1.10.2'; 
import isPageEditor from 'GlobalsScript/is-page-editor.js';

var showing = null;

(function (window, document, $) {
    $(document).ready(function () {
        

        // hide the element that has the #id in the URL; prevent default scrolling for IE
        // add it as a backup to a new variable in case the URL changes

        var menuLoaded = 1;
        if ($('ul.anchormenu').length > 0) {
            menuLoaded = 0;
        }
        if (location.hash && menuLoaded == 0) {
            if (!$(location.hash).hasClass("faq-item")) {
                $(location.hash).hide();
                var hiddenAnchor = location.hash;
            }
        }

        // Anchortag    
        $('ul.anchormenu li a[href^="#"]').each(function () {
            var currentlink = $(this);
            var target = $(this).attr("href");
            var current = '#';
            var menuItemHeight = $(this).parents('section').height() + 30;
            // scroll into position only once if there's an #id in the URL
            $(document).imagesLoaded().always(function () {
                
                    if (menuLoaded == 0) {
                        if (location.hash) {
                            scrollHash(location.hash, menuItemHeight);
                        }
                        menuLoaded = 1;
                    }
                
            });
            
            $(window).scroll(function () {
                $(hiddenAnchor).show();
                $('section a[name]').each(function () {
                    var reached = '#' + $(this).attr("id");
                    var windowtop = $(window).scrollTop();
                    var dfromtop = $(this).offset().top;
                    
                    if (windowtop > dfromtop - 111) { current=reached }
                    if (current==target) {
                        // red bar goes under current link
                        if ($('ul.anchormenu li a[href^="#"]').parent('div').length > 0) {
                            $('ul.anchormenu li a[href^="#"]').parent().parent().removeClass('currentanchor');
                            currentlink.parent().parent().addClass('currentanchor');
                        } else {
                            $('ul.anchormenu li a[href^="#"]').parent().removeClass('currentanchor');
                            currentlink.parent().addClass('currentanchor');
                        }
                    }
                });
                $(hiddenAnchor).hide();
            });

            // anchor menu click actions

            $(this).click(function () {
                scrollHash(target, menuItemHeight);
                return false;
            });
            $(this).attr("href", "#");
        });

        // Anchor end

    });

})(window, document, jQuery);



/* Set a sub menu to be sticky */
function stickyMenu(itemClass, $) {
    var imagesLoaded = require('imagesloaded');
    imagesLoaded.makeJQueryPlugin( $ );
    /* Ensure all the images on the page are loaded to properly calculate offset */
    jQuery(function ($) { 
        $(document).imagesLoaded().always(function () {
            if (isPageEditor() == false && itemClass != '') {
                var fullItemClass = '.' + itemClass;
                var itemcl = $(fullItemClass);
                var thisSection = itemcl.closest("section");
                var ribbon = $('#scWebEditRibbon');
                var positionItem = itemcl.position();
                var top = itemcl.offset().top - parseFloat(itemcl.css('marginTop').replace(/auto/, 100));
                var itemLink = itemcl.find("a");

                if (($(thisSection).is(":visible"))) {
            
                    var y = $(window).scrollTop();
                    if (y >= top) {
                        itemcl.addClass('stickymenu');

                        if (typeof Sitecore == "undefined") {
                            itemcl.animate({ top: '0', left: '50%', marginLeft: '-' + (itemcl.parent().parent().width() / 2) + 'px' }, 0);
                            itemcl.width(itemcl.parent().parent().width());
                        } else {
                            itemcl.animate({ top: $('#scWebEditRibbon').height() }, 0);
                            itemcl.width(itemcl.parent().parent().width());
                        }
                    } else {
                        itemcl.removeClass('stickymenu');
                        itemcl.removeAttr('style');
                    }

                }
            

                itemLink.click(function () {
                    if (!(itemcl.hasClass('stickymenu'))) {
                        if (typeof Sitecore == "undefined") {
                        } else {
                            $("#main").animate({ top: $('#scWebEditRibbon').height() + 100 }, 0);
                            $("#main").css("margin-bottom", $('#scWebEditRibbon').height() + 100 + "px");
                        }
                    }
                });

                function doStick(){
                    /* Don't calculate when section is hidden */
                    if (!($(thisSection).is(":visible"))) {
                        return;
                    }
                    /* Don't sticky when the mobile menu is opened
                     * Also don't sticky when on mobile and landscape mode
                      */
                    if ($('main').hasClass('menu-open') || (($('.mobile-menu:visible').length > 0 && $('.show-on-desktop').length<1) && $(window).height() < $(window).width())) {
                        return;
                    }
                    
                    var y = $(window).scrollTop();
                   
                    if (y >= top) {
                        itemcl.addClass('stickymenu');
                        /* Add the height of the element to inline styling, so the site doesn't jump up */
                        itemcl.closest('section').height(itemcl.height());

                        if (typeof Sitecore == "undefined") {
                            itemcl.animate({ top: '0', left: '50%', marginLeft: '-' + (itemcl.parent().parent().width() / 2) + 'px' }, 0);
                            itemcl.width(itemcl.parent().parent().width());
                        } else {
                            itemcl.animate({ top: $('#scWebEditRibbon').height() }, 0);
                            itemcl.width(itemcl.parent().parent().width());
                        }
                    } else {
                        itemcl.removeClass('stickymenu');
                        itemcl.removeAttr('style');
                    }

                }
                $(window).scroll(function (event) {
                    doStick();
                });
                $(window).resize(function (e) {
                    top = $(thisSection).offset().top;
                    doStick();
                });
            }
        });
    });
}

function scrollHash(hash, menuHeight) {
    jQuery(hash).show();
    var anchorControl = jQuery(hash);
    if (anchorControl.length == 0) {
        var anchorName = hash.replace('#', '');
        anchorControl = jQuery("a[name='" + anchorName + "']");
    }

    if (anchorControl.length != 0) {
        // Check if the anchor is for a collapsible entry and open it if it is.
        var collapsibleEntryHeader = jQuery(anchorControl).siblings(".collapsibleHeader");
        if (collapsibleEntryHeader.length != 0) {
            toggleCollapsibleContent(collapsibleEntryHeader, false);
        }

        var position = anchorControl.offset().top - menuHeight;
        jQuery("html, body").animate({ scrollTop: position }, 300, "linear");
        location.hash = hash;
    }
}(jQuery);
window.stickyMenu = stickyMenu;
window.scrollHash = scrollHash;
window.jQuery = jQuery;

